import { createContext } from 'react';

export const ColorFamilyContext = createContext({});
export const ColorDetailsContext = createContext({});
export const CompareContext = createContext({});
export const LayoutContext = createContext({});